<template>
    <div class="register">
        <div class="re-title">用户信息</div>
        <Form ref="formInline" :model="formInline" :rules="ruleInline" label-position="right" :label-width="130"
            @submit.native.prevent
            style="width:500px;margin:0 auto;cursor: pointer;color:#d13119;padding-bottom: 20px;">
            <FormItem label="手机号：" prop="phone">
                <Input type="text" style="width:300px;" disabled v-model="formInline.phone" placeholder="请输入手机号" />
                <span @click="phoneModel = true" style="margin-left: 20px;">修改</span>
            </FormItem>

            <FormItem label="姓名：" prop="linkMan">
                <Input type="text" style="width:300px;" v-model="formInline.linkMan" placeholder="请输入姓名" />
            </FormItem>
            <FormItem label="公司：" prop="company">
                <Input type="text" style="width:300px;" v-model="formInline.company" placeholder="请输入公司" />
            </FormItem>
            <FormItem label="职务：" prop="job">
                <Select v-model="formInline.job" style="width:300px" clearable placeholder="请选择职务">
                    <Option v-for="item in jobList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </FormItem>

            <FormItem label="邮箱：" prop="email">
                <Input type="text" style="width:300px;" v-model="formInline.email" placeholder="请输入邮箱" />
            </FormItem>


            <FormItem label="城市：" prop="city">
                <Cascader v-model="formInline.city" placeholder="请选择城市" style="width:300px;height:42px;"
                    change-on-select :load-data="loadData" :data="provinceArr"></Cascader>
            </FormItem>


            <FormItem label="产品类别偏好：" prop="productPerfer">
                <Select v-model="formInline.productPerfer" style="width:300px" placeholder="请选择产品类别偏好" clearable>
                    <Option v-for="item in product_category_list" :value="item.value" :key="item.value">{{ item.value }}
                    </Option>
                </Select>
            </FormItem>
            <FormItem label="所在领域：" prop="domainBelong">
                <Select v-model="formInline.domainBelong" style="width:300px" clearable placeholder="请选择所在领域">
                    <Option v-for="item in domain_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </FormItem>



            <!-- <FormItem style="width:300px;margin-left:120px;" class="terms">
                <Checkbox v-model="agree">
                    <span style="padding-left: 4px;">我已阅读并同意</span>
                </Checkbox>
                <span class="re-tip-info" @click="showModel = true">《注册隐私条款》</span>
            </FormItem> -->
            <Button type="primary" @click="handleSubmit('formInline')" size="large" :loading="loading" style="margin-top: 40px;"
                class="re-btn">确认提交修改</Button>
        </Form>
        <iModal v-model="showModel" name="my-modal" footer-hide width="800">
            <h2 style="text-align: center;font-size: 20px;">用户注册服务条款</h2>
            <pre style="padding: 40px 0;white-space: pre-wrap;word-wrap: break-word;">
            尊敬的客户您好，欢迎您访问CMEF（cmef.com.cn）平台（以下简称：平台）。在您使用我方提供的服务时，请详细了解我方收集、存储、使用、披露和保护您的个人信息的举措，进而帮助您更好地保护您的隐私，使平台更好的为您服务。
            在您注册成为平台会员时，建议您认真阅读和理解《平台用户注册协议》、《隐私政策》中所有的条款，在您同意本注册协议和隐私条款后，即可享受CMEF平台的服务。在使用我方各项产品和服务时，及表示您已同意我们按照本协议条款来合法收集、使用和保护您的个人信息。
            感谢您对CMEF平台的信任。

            平台用户注册协议
            一、总则
            此份协议是注册用户接受cmef.com.cn网站（以下简称本站）产品和服务时适用的通用条款。因此，请您在注册成为本站用户前或接受本站的产品和服务之前，请您详细地阅读本注册用户协议的所有内容。
            1、注册用户了解并同意：
            ①只要注册用户点击 “同意”按钮并完成注册，注册用户就已接受了本注册用户协议及本站公布的各项服务规则（包括填写实名的联系方式等等），并愿意受其约束。如果发生纠纷，注册用户不得以未仔细阅读为由进行抗辩。
            ②随着市场经营情况的变化，本站有权随时更改本注册用户协议及相关服务规则。修改本注册用户协议时，本站将于相关页面公告修改的事实，有权不对注册用户进行个别通知。注册用户应该在每次登录前查询网站的相关公告，以了解注册用户协议及其他服务规则的变化。
            ③为更好地为用户提供服务，网站将收集您的姓名、公司、职位、手机号、邮箱等信息；用户在注册时应当选择稳定性及安全性相对较好的电子邮箱，并且同意接受并阅读网站发往用户的各类电子邮件。如用户未及时从自己的电子邮箱接受电子邮件或因用户电子邮箱或用户电子邮件接收及阅读程序本身的问题使电子邮件无法正常接收或阅读的，只要网站成功发送了电子邮件，应当视为用户已经接收到相关的电子邮件。电子邮件在发信服务器上所记录的发出时间视为送达时间。
            2、若注册用户不同意本注册用户协议或相关服务规则，或者不同意本站作出的修改，注册用户可以主动停止使用本站提供的产品和服务，如果在本站修改协议或服务规则后，注册用户仍继续使用本站提供的产品和服务，即表示注册用户同意本站对本注册用户协议及相关服务规则所做的所有修改。由于注册用户在注册用户协议变更后因未熟悉公告规定而引起的损失，本站将不会承担任何责任。
            3、本站的各项电子服务的所有权和运作权归本站。本站提供的服务将完全按照其发布的服务条款和操作规则严格执行。注册用户必须完全同意所有服务条款并完成注册程序，才能成为本站的注册用户。注册用户确认：本协议条款是处理双方权利义务的当然约定依据，除非违反国家强制性法律，否则始终有效。
            二、服务简介
            1、本站运用自己的操作系统通过国际互联网络为注册用户提供网络服务。同时，注册用户必须：自行配备上网的所需设备，包括个人电脑、调制解调器或其他必备上网装置。自行负担个人上网所支付的与此服务有关的电话费用、网络费用。
            2、基于本站所提供的网络服务的重要性，注册用户应同意：提供详尽、准确的个人资料。不断更新注册资料，符合及时、详尽、准确的要求。
            3、本站对注册用户的电子邮件、手机号等隐私资料进行保护，承诺不会在未获得注册用户许可的情况下擅自将注册用户的个人资料信息出租或出售给任何第三方，但以下情况除外：注册用户同意让第三方共享资料；注册用户同意公开其个人资料，享受为其提供的产品和服务；本站需要听从法庭传票、法律命令或遵循法律程序；本站发现注册用户违反了本站服务条款或本站其它使用规定。
            4、关于注册用户隐私的具体协议以本站的隐私声明为准。如果注册用户提供的资料包含有不正确的信息，本站保留结束注册用户使用网络服务资格的权利。
            三、账号密码和安全性
            ①用户可以通过在网站注册或使用其他合作网站的账号使用网站提供的各项服务。用户注册成功后，网站将给用户一个账号及密码，每个账号对应一个唯一的名字（或昵称、用户名）。网站账号的所有权归网站，用户完成申请注册手续后，获得的网站账号的使用权，但仅限为与网站相关的业务或服务而非其它商业目的使用。
            ②用户须妥善管理自己的用户名及密码，禁止赠与、借用、租用、转让或者售卖。若出于您的原因导致密码泄露，您需自行承担相应的一切责任。
            ③用户账号和密码遭到他人非法使用或发生其他任何安全问题，用户应当立即联系网站。网站在收到用户要求采取措施暂停其账号登录和使用的申请后，应当要求用户提供与其注册身份信息一致的个人有效身份信息及其他证件和资料。网站核实审查无误后，应当及时采取措施暂停用户账号的登录和使用。用户没按要求提供相关信息或者信息有误，网站有权拒绝用户的前述请求。
            ④用户每次使用完网站相关服务后，请关闭退出有关账号。因黑客行为或用户的过错导致账号、密码或被他人非法使用，网站不承担任何责任。

            四、拒绝提供担保
            注册用户个人对网络服务的使用承担风险。本站对此不作任何类型的担保，不论是明确的或隐含的，但是不对商业性的隐含担保、特定目的和不违反规定的适当担保作限制。本站不担保服务一定能满足注册用户的要求，也不担保服务不会受中断，对服务的及时性，安全性，出错发生都不作担保。
            五、有限责任
            本站对任何直接、间接、偶然、特殊及继起的损害不负责任，这些损害可能来自：不正当使用网络服务，在网上购买商品或进行同类型服务，在网上进行交易，非法使用网络服务或注册用户传送的信息有所变动。这些行为都有可能会导致本站的形象受损，所以本站事先提出这种损害的可能性。
            六、通告
            所有发给注册用户的通告都可通过重要页面的公告或电子邮件或常规的信件传送。本站的活动信息也将定期通过页面公告及电子邮件方式向注册用户发送。注册用户协议条款的修改、服务变更、或其它重要事件的通告会以电子邮箱或者短信进行通知。
            七、责任限制
            1、如因不可抗力或其他本站无法控制的原因使本站销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，本站不承担责任。但是本站会尽可能合理地协助处理善后事宜，并努力使客户免受经济损失。
            2、除了本站的使用条件中规定的其它限制和除外情况之外，在中国法律法规所允许的限度内，对于因交易而引起的或与之有关的任何直接的、间接的、特殊的、附带的、后果性的或惩罚性的损害，或任何其它性质的损害，本站、本站的董事、管理人员、雇员、代理或其它代表在任何情况下都不承担责任。
            八、法律管辖和适用
            1、本协议的订立、执行和解释及争议的解决均应适用中国法律。
            2、如发生本站服务条款与中国法律相抵触时，则这些条款将完全按法律规定重新解释，而其它合法条款则依旧保持对注册用户产生法律效力和影响。
            3、本协议的规定是可分割的，如本协议任何规定被裁定为无效或不可执行，该规定可被删除而其余条款应予以执行。
            4、如双方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向本站所在地的北京人民法院提起诉讼。
            九、用户承诺
            您在平台的所有行为都不需符合中国的法律法规，您不得利用平台提供的服务制作、复制、发布、传播以下信息：
            1.违反宪法基本准则的；
            2.危害国家安全、泄露国家秘密、颠覆国家政权、破坏国家统一的；
            3.损害国家荣誉和利益的；
            4.煽动民族仇恨、民族歧视、破坏民族团结的；
            5.皮怀国家宗教政策，宣扬邪教和封建迷信的；
            6.散布谣言、扰乱社会秩序、破坏社会稳定的；
            7.散布淫秽、色情、赌博、暴力、恐怖内容或者教唆犯罪的；
            8.侮辱或者诽谤他人，侵害他人合法权益的；
            9.以及法律、法规禁止的其他内容；
            十、用户管理
            用户在使用网站服务过程中，必须遵循以下原则：
            1.遵守中国有关的法律和法规；
            2.不得为任何非法目的而使用网络服务系统；
            3.遵守所有与网络服务有关的网络协议、规定和程序；
            4.不得利用网站服务系统进行任何可能对互联网的正常运转造成不利影响的行为；
            5.不得利用网站服务系统传输任何骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料；
            6.不得利用网站服务系统进行任何不利于网站的行为；
            7.就网站及合作商业伙伴的服务、产品、业务咨询应采取相应机构提供的沟通渠道，不得在公众场合发布有关网站及相关服务的负面宣传；
            8.不得以任何方式危害未成年人。
            9.网站中企业LOGO、产品图片等均具有知识产权效益，未经企业同意用户不得私自使用网站中的文字图片；
            10.平台内在线产品的所有权归CMEF平台方所有，不得对平台内的图片、文字进行非法使用和恶意传播

            十一、其他规定
            1、如本用户协议中的任何内容无论因何种原因完全或部分无效或不具有执行力，本用户协议的其余内容仍应有效并且对协议各方有约束力。
            2、本用户协议中的标题仅为方便而设，不具法律或契约效果。

            隐私政策
            引言
            CMEF平台方重视用户的隐私，隐私权是您重要的权利，您在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》向您说明，在您享受CMEF平台服务时，我们如何收集、使用储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。本《隐私政策》与您所使用的CMEF服务息息相关，希望您仔细阅读，在需要时，按照本《隐私政策》的指引，做出您认为适当的选择。您使用或继续使用我们的服务，即代表您同意我们按照本《隐私政策》收集、使用、储存和分享您的相关信息。
            如对本《隐私政策》或相关事宜有任何问题，请通过CMEF网站公布的平台联系人与我们工作人员取得联系。
            我们提供服务时，为及时对您的需求做出准确答复，将收集 、储存和使用下列与您相关信息。如果您不提供相关信息，可能成为我们的用户或无法享受我们提供的某些服务，或无法达到相关服务拟达到的目的。
            您提供的信息：您在注册账户或使用我们的服务时，需向平台提供您的相关个人信息，如姓名（或昵称）、电话号码、电子邮件、公司名称、职位等；您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息。
            其他方分享的您的信息：其他方使用我们的服务时所提供有关您的共享信息。
            我们可能如何使用您的信息：
            我们可能将在向您提供服务的过程中所收集的信息做下列用途：
            1.向您提供服务；
            2.向您及时提供平台相关活动及信息，通过邮件、短信等形式告知您；
            3.针对您的商贸需求平台专业客服人员及时为您匹配资源；
            个人信息管理：
            您可在平台个人账户中随时更新您的信息。我们将尽可能采取适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。
            个人信息安全：
            除以下情况外，未经您同意，平台以及与平台相关网站不会向第三方分享您的个人信息。
            平台以及与平台相关网站可能能将您的个人信息与我们关联的公司、合作伙伴或第三方服务供应商、承包商、代理分享，用作以下用途：
            平台向所有会员发送平台相关通知；
            实现“我们可能如何使用信息”部分所述目的；
            平台整体升级时数据的转移与沿用；
            如平台或平台相关公司与任何上述第三方分享您的信息，我们将努力确保该第三方在使用您的信息时遵守本《隐私政策》及我们要求其遵守的其他相关保密协议和安全措施。
            平台和平台的相关公司还可能为以下需要而保留、保存或披露您的个人信息：
            遵守使用的法律法规；
            遵守法院命令或其他法律程序的规定；
            遵守相关政府机关的要求；
            为遵守使用的法律法规、维护社会公共利益，或保护平台的客户、平台或平台的集团公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途。
            信息安全
            我们将在本《隐私政策》所述目的所必需的期间和法律法规要求的时限内保留您的个人信息。

              </pre>
            <div class="f-tac">
                <Button type="primary" size="large" @click="agree = true; showModel = false">接受</Button>
            </div>
        </iModal>




        <iModal v-model="phoneModel" name="my-modal" footer-hide width="800">
            <div class="register" style=" width: 770px;margin: 60px auto 60px">
                <div class="re-title"></div>
                <div class="" style="display: flex;justify-content: center; align-items: center;">
                    <Form ref="formInline2" :model="formInline2" :rules="ruleInline2" label-position="right"
                        :label-width="130" @submit.native.prevent style="width:500px;">
                        <FormItem label="手机号：" prop="phone">
                            <Input type="text" style="width:300px;" v-model="formInline2.phone" placeholder="请输入新手机号" />
                        </FormItem>
                        <FormItem label="验证码：" prop="code" style="position:relative;">
                            <Input type="text" style="width:300px;" v-model="formInline2.code" placeholder="短信验证码" />
                            <span v-if="showCode" @click="getCaptcha" class="txt-code">获取验证码</span>
                            <span v-else class="txt-code disabled">{{ count }}s后重新获取</span>
                        </FormItem>
                    </Form>
                    <!-- <Button type="primary" size="large" @click="agree = true; phoneModel = false">接受</Button> -->
                </div>
            </div>
            <div style="text-align: end;">
                <Button type="" @click="handleReset('formInline2')" size="large" :loading="loading2"
                    class="re-btn">取消</Button>
                <Button type="primary" @click="handleSubmit2('formInline2')" size="large" :loading="loading2"
                    style="margin-left: 20px;" class="re-btn">确定</Button>
            </div>
        </iModal>


    </div>
</template>

<script>
import { validator } from "@/other/validator";
import { mapActions } from "vuex";
import { provinces } from "@/other/provinces";
export default {
    name: "exhibition-register",
    data () {
        return {
            loading: false,
            agree: false,
            showModel: false,
            formInline: {
                phone: "",
                imgCode: "",
                code: "",
                password: "",
                linkMan: "",
                email: "",
                company: "",
                job: "",
                city: [],
                // city: ['山西省', '长治市','襄垣县'],

                productPerfer: "",
                domainBelong: "",
            },
            ruleInline: {
                phone: validator.phone,
                imgCode: [
                    {
                        required: true,
                        message: "请输入图片验证码",
                        trigger: "blur"
                    }
                ],
                code: [
                    {
                        required: true,
                        message: "请输入验证码",
                        trigger: "blur"
                    }
                ],
                company: [
                    {
                        required: true,
                        message: "请输入公司",
                        trigger: "blur"
                    }
                ],
                job: [
                    {
                        required: true,
                        message: "请输入职务",
                        trigger: "blur"
                    }
                ],
                password: [
                    { required: true, message: "密码不能为空", trigger: "blur" },
                    {
                        type: "string",
                        min: 4,
                        message: "密码不能小于4位",
                        trigger: "blur"
                    },
                    {
                        type: "string",
                        max: 12,
                        message: "密码不能大于12位",
                        trigger: "blur"
                    }
                ],
                linkMan: [
                    {
                        required: true,
                        message: "请输入姓名",
                        trigger: "blur"
                    }
                ],
                productPerfer: [
                    {
                        required: true,
                        message: "请选择产品类别偏好",
                        trigger: "blur"
                    }
                ],
                domainBelong: [
                    {
                        required: true,
                        message: "请选择所在领域",
                        trigger: "blur"
                    }
                ],
                city: [
                    { required: true, type: 'array', message: '请选择城市', trigger: 'change' },
                    { type: 'array', message: '', trigger: 'change' }
                ],
                // city: [
                //   {
                //     required: true,
                //     message: "请选择城市",
                //     trigger: "blur"
                //   }
                // ],
                email: [
                    { required: true, message: "邮箱不能为空", trigger: "blur" },
                    { type: "email", message: "邮箱格式有误", trigger: "blur" }
                ]
            },
            cityList: [
                {
                    value: "北京",
                    label: "北京"
                },
                {
                    value: "上海",
                    label: "上海"
                }
            ],

            jobList: [
                {
                    value: "董事长/董事/总裁/总经理/院长/校长/政府高级官员",
                    label: "董事长/董事/总裁/总经理/院长/校长/政府高级官员"
                },
                {
                    value: "事业部/部门负责人/总监",
                    label: "事业部/部门负责人/总监"
                },
                {
                    value: "经理",
                    label: "经理"
                },
                {
                    value: "普通职员",
                    label: "普通职员"
                },
                {
                    value: "科研人员(研究员，工程师等)",
                    label: "科研人员(研究员，工程师等)"
                },
                {
                    value: "科室主任/处长/科长",
                    label: "科室主任/处长/科长"
                },
                {
                    value: "医务人员",
                    label: "医务人员"
                },
                {
                    value: "主管",
                    label: "主管"
                },
                {
                    value: "教师/教练",
                    label: "教师/教练"
                },
                {
                    value: "学生",
                    label: "学生"
                },
            ],



            imgCode: null, // 图片二维码信息
            showCode: true, // 是否可以获取验证码
            count: "",// 获取验证码的秒数

            product_category_list: null,
            domainBelong: null,


            domain_list:
                [
                    {
                        value: "代理商/经销商/进出口/招投标 经营企业及个体",
                        label: "代理商/经销商/进出口/招投标 经营企业及个体"
                    },
                    {
                        value: "电商/微商/零售",
                        label: "电商/微商/零售"
                    },
                    {
                        value: "药店、零售、商超、百货",
                        label: "药店、零售、商超、百货"
                    },
                    {
                        value: "医疗机构/体检机构 医疗卫生/服务机构",
                        label: "医疗机构/体检机构 医疗卫生/服务机构"
                    },
                    {
                        value: "民政/残联/康复/养老院/社会福利机构运营商/系统集成商/医疗信息化",
                        label: "民政/残联/康复/养老院/社会福利机构运营商/系统集成商/医疗信息化"
                    },
                    {
                        value: "生产商/制造商 生产企业",
                        label: "生产商/制造商 生产企业"
                    },
                    {
                        value: "供应链/元器件、包装",
                        label: "供应链/元器件、包装"
                    },
                    {
                        value: "科研机构/投融资机构",
                        label: "科研机构/投融资机构"
                    },
                    {
                        value: "设计院/工程总包",
                        label: "设计院/工程总包"
                    }
                ],




            cmefUpdate: null,
            phoneModel: false,
            loading2: false,
            infoData: {},


            formInline2: {
                phone: "",
                code: "",

            },
            ruleInline2: {
                phone: validator.phone,
                // phone: [
                //     {
                //         required: true,
                //         message: "请输入新手机号",
                //         trigger: "blur"
                //     }
                // ],
                code: [
                    {
                        required: true,
                        message: "请输入验证码",
                        trigger: "blur"
                    }
                ],
            },



        };
    },
    components: {},
    computed: {},


    created () {

        this.getCode();
        this.productPerferGetQ();
        this.provinceArr = provinces.data;


        // cmef 跳转过来修改信息
        this.cmefUpdate = this.$route.query.type
        let userInfo = JSON.parse(this.$route.query.info)
        this.infoData = JSON.parse(this.$route.query.info)
        console.log(this.cmefUpdate);
        console.log(userInfo);
        if (userInfo) {
            this.formInline.phone = userInfo.phoneNumber
            this.formInline.linkMan = userInfo.name
            this.formInline.company = userInfo.compName
            this.formInline.job = userInfo.jobTitle
            this.formInline.email = userInfo.email

            if (userInfo.province) {
                this.formInline.city.push(userInfo.province)
                if (userInfo.city) {
                    this.formInline.city.push(userInfo.city)
                    if (userInfo.county) {
                        this.formInline.city.push(userInfo.county)
                    }
                }
            }
            this.formInline.productPerfer = userInfo.productPerfer
            this.formInline.domainBelong = userInfo.domainBelong
        }
        console.log(this.formInline.city);

    },

    methods: {
        ...mapActions({
            getImgCode: "loginModule/getImgCode",
            validateImgCode: "loginModule/validateImgCode",
            getMsgCode: "loginModule/getMsgCode",
            postAddMember: "loginModule/postAddMember",
            validateMsgCode: "loginModule/validateMsgCode",
            audienceRegister: "loginModule/audienceRegister",
            checkUserName: "loginModule/checkUserName",
            getProductPerfer: "loginModule/getProductPerfer",
            updateRegister: "loginModule/updateRegister",
        }),


        async productPerferGetQ () {
            let bool = await this.getProductPerfer();
            if (bool.length > 0) {
                this.product_category_list = bool
                console.log(this.product_category_list, 'this.product_category_lis');
            }
        },

        async handleSubmit2 (name) {
            let form = this.formInline2;
            // 验证表单
            let valid = await this.validForm(name);
            if (!valid) return;
            // 验证图片验证码
            //   let codeValid = await this.validImgCode();
            //   if (!codeValid) return;
            // 验证文字验证码
            let txtValid = await this.validTxtCode();
            if (!txtValid) return;
            this.loading2 = true;
            this.formInline.phone = form.phone
            setTimeout(() => {
                this.loading2 = false;
            }, 5000);
            this.loading2 = false;
        },
        handleReset (name) {
            this.$refs[name].resetFields();
            this.phoneModel=false
        },
        async handleSubmit (name) {
            console.log(this.infoData, 'this.infoData');
            console.log(this.formInline, 'this.formInline');
            let form = this.formInline;
            // 验证表单
            let valid = await this.validForm(name);
            if (!valid) return;
            let req = {
                id: this.infoData.id || this.infoData.userId,
                setValues: {
                    PhoneNumber: form.phone,
                    Name: form.linkMan,
                    CompName: form.company,
                    JobTitle: form.job,
                    Email: form.email,
                    Province: form.city.length ? form.city[0] : "",
                    City: form.city.length ? form.city[1] : "",
                    Country: form.city.length ? form.city[2] : "",
                    ProductPerfer: form.productPerfer,
                    DomainBelong: form.domainBelong,
                }
            };
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 5000);
            let bool = await this.updateRegister(req);
            if (bool.successed) {
                this.loading = false;
                this.$Message.success("修改成功");
                // this.$router.push(this.$route.query.returnUrl);
                window.location.href=this.$route.query.returnUrl

            } else {
                this.loading = false;
                if (bool.errors && bool.errors[0]) {
                    this.$Message.error(bool.errors[0].description);
                    return;
                } else {
                    this.$Message.error("注册失败，请重新尝试");
                }
            }
            this.loading = false;
        },
        validForm (name) {
            // 验证表单
            return new Promise((resolve, reject) => {
                this.$refs[name].validate(valid => {
                    resolve(valid);
                });
            });
        },
        async validImgCode () {
            // 验证图片code
            if (!this.imgCode || !this.formInline.imgCode) return false;
            let valid = await this.validateImgCode({
                Key: this.imgCode.key,
                Code: this.formInline.imgCode
            });
            if (!valid) {
                this.$Message.error("图片验证码未通过!");
                return false;
            }
            if (valid.errors && valid.errors[0]) {
                this.$Message.error(valid.errors[0].description);
                this.getCode();
                return false;
            }
            return true;
        },
        async validTxtCode () {
            // 验证文字code
            if (!this.formInline2.code) return false;
            let valid = await this.validateMsgCode({
                Phone: this.formInline2.phone,
                Code: this.formInline2.code
            });
            if (!valid) {
                this.$Message.error("验证未通过!");
                return false;
            }
            if (valid.errors && valid.errors[0]) {
                this.$Message.error(valid.errors[0].description);
                return false;
            }
            return true;
        },
        async getCode () {
            // 获取图片code
            this.imgCode = await this.getImgCode();
        },
        async getCaptcha () {
            // 获取文字验证码
            this.$refs.formInline2.validateField("phone", val => { });
            //   this.$refs.formInline.validateField("imgCode", val => {});
            //   let codeValid = await this.validImgCode();
            //   if (!codeValid) return;
            this.$refs.formInline2.validateField("phone", val => {
                if (val !== "") return;
                this.downTime();
            });
        },
        async downTime () {
            const valid = await this.getMsgCode(this.formInline.phone);
            const TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.showCode = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                    } else {
                        this.showCode = true;
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000);
            }
        },
        loadData (item, callback) {
            item.loading = true;
            setTimeout(() => {
                console.log(item);
                item.loading = false;
                callback();
            }, 1000);
        }
    },

};
</script>

<style scoped lang="scss">
.register {
    width: 1200px;
    margin: 60px auto 130px;

    .re-title {
        font-size: 20px;
        text-align: center;
        color: #333;
        margin-bottom: 40px;
        padding-left: 40px;
    }

    ::v-deep .ivu-input {
        height: 42px;
    }

    ::v-deep .ivu-form-item-label {
        color: #222;
        height: 42px;
        padding-top: 0;
        padding-bottom: 0;
        line-height: 42px;
    }

    ::v-deep .ivu-select-selection {
        height: 42px;
    }

    ::v-deep .ivu-select-placeholder {
        line-height: 42px;
    }

    ::v-deep .ivu-select-selected-value {
        line-height: 42px;
    }

    .re-btn {
        width: 300px;
        height: 42px;
        margin-left: 120px;
        font-size: 18px;
    }

    .re-tip-info {
        margin-left: -10px;
        color: #1890ff;
        cursor: pointer;
    }

    .terms {
        ::v-deep .ivu-form-item-content {
            margin-left: 0 !important;
            text-align: center;
        }
    }

    .img-code {
        width: 70px;
        height: 30px;
        position: absolute;
        top: 6px;
        left: 224px;
        cursor: pointer;
    }

    .txt-code {
        position: absolute;
        top: 5px;
        left: 224px;
        cursor: pointer;
        color: #1890ff;
    }

    .disabled {
        color: #ccc;
        left: 202px;
    }
}
</style>
